import { Reducer } from 'redux';
import { IPriceListStateStore } from './type';
import { TypesPriceList } from 'redux/actions/priceList/type';

const priceListState: IPriceListStateStore = {
  priceList: null,
  promo_code: undefined,

  isLoading: false,
  isLoaded: false,
  isFailed: false,
};

export const priceList: Reducer<IPriceListStateStore> = (state = priceListState, action) => {
  switch (action.type) {
    case TypesPriceList.GET_PRICE_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case TypesPriceList.GET_PRICE_LIST_SUCCESS: {
      return {
        ...state,
        priceList: action.data.priceList,

        isLoading: false,
        isLoaded: true,
        isFailed: false,
      };
    }

    case TypesPriceList.GET_PRICE_LIST_ERROR:
      return {
        ...state,

        isLoading: false,
        isFailed: true,
      };

    default:
      return state;
  }
};
